import { render, staticRenderFns } from "./ScatterLanding.vue?vue&type=template&id=6065e9ae&scoped=true"
import script from "./ScatterLanding.vue?vue&type=script&lang=js"
export * from "./ScatterLanding.vue?vue&type=script&lang=js"
import style0 from "./ScatterLanding.vue?vue&type=style&index=0&id=6065e9ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6065e9ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VListItem,VSpacer,VTextField})
